export enum CountryCodesEnum {
  USA = "US",
  Canada = "CA",
  UnitedKingdom = "UK",
  Australia = "AU",
  Germany = "DE",
  China = "CN",
  Japan = "JP",
}
